import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";

export const BooleanCell = ({ positive }: { positive: boolean }) => {
  return positive ? (
    <CheckCircleOutlined style={{ color: "#00fca3" }} />
  ) : (
    <CloseCircleOutlined style={{ color: "#ec4339" }} />
  );
};
